import { ThematicFolderDto } from "../../../models/ThematicFolderDto";
import React, { useState } from "react";
import { Media, Row, Table } from "reactstrap";
import styles from "./thematicFolderList.module.scss";
import { translate } from "react-switch-lang";
import hasRoles from "../../../security/hasRoles";
import keycloak from "../../../security/keycloak-config";
import { toast } from "react-toastify";
import { RootState } from "../../../store";
import { useSelector } from "react-redux";
import ClickAwayListener from "react-click-away-listener";
import Pdf from "../../../assets/images/icons/pdf.png";
import ReactPlayer from "react-player/lazy";
import { CountryDto } from "../../../models/countryDto";
import { ThematicDto } from "../../../models/thematicDto";

const ThematicFolderList: React.FC<{
  t: (key: string) => {};
  currentPage: number;
  elementPerPage: number;
  listFilterThematicFolder: ThematicFolderDto[];
  listMedia: any[];
  handleClickCategory: () => void;
  handleUpdateThematicFolder: (data: ThematicFolderDto) => void;
  handleRemoveThematicFolder: (id: number) => void;
  handleClickThematicFolder: (id: number) => void;
  handleClickImage: (data: any) => void;
  removeMediaById: (id: number) => void;
}> = props => {
  toast.configure();
  const hasRoleAdmin = hasRoles(["ROLE_MEDIATHEQUE_ADMIN"], keycloak);
  const [, setSortColumn] = useState<string>("");
  const selectedLanguage = useSelector((state: RootState) => state.language.currentLang);
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const [indexVideo, setIndexVideo] = useState<number>(0);

  const sortTrainingPathList = (sortColumnName: string) => {
    setSortColumn(sortColumnName);
  };

  const toggle = index => {
    setDropdownOpen(!dropdownOpen);
    setIndexVideo(index);
  };

  return (
    <>
      <Row className={styles["document-table-row"]}>
        <div className={styles["container-table"]}>
          <Table className={styles["document-table"]}>
            <thead>
              <tr>
                <th className={styles["document-table-icon"]} scope="col"></th>
                <th className={styles["document-table-nom"]} scope="col">
                  <span onClick={() => sortTrainingPathList("SUPPORT_TITLE")} className={styles["pointer"]}>
                    {props.t("table_header.title")}
                  </span>
                </th>
                <th className={styles["document-table-type"]} scope="col">
                  <span onClick={() => sortTrainingPathList("SUPPORT_VIDEO_TYPE")} className={styles["pointer"]}>
                    {props.t("table_header.media_type")}
                  </span>
                </th>
                <th className={styles["document-table-type"]} scope="col">
                  <span onClick={() => sortTrainingPathList("SUPPORT_VIDEO_TYPE")} className={styles["pointer"]}>
                    {"Pays"}
                  </span>
                </th>
                <th className={styles["document-table-type"]} scope="col">
                  <span onClick={() => sortTrainingPathList("SUPPORT_VIDEO_TYPE")} className={styles["pointer"]}>
                    {"Thématique"}
                  </span>
                </th>
                {hasRoleAdmin && (
                  <th className={styles["document-table-actions"] + " text-center"} scope="col">
                    {props.t("table_header.actions")}
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {props.listFilterThematicFolder.map(
                (data: ThematicFolderDto, index: number) =>
                  props.currentPage * props.elementPerPage <= index &&
                  (props.currentPage + 1) * props.elementPerPage > index && (
                    <tr key={data.thematicFolderId}>
                      <td>
                        <div className={styles["card-style"] + " blog-box blog-grid text-center product-box"}>
                          <div className="product-img text-center">
                            <Media
                              onClick={() => props.handleClickThematicFolder(data.thematicFolderId)}
                              className={styles["img-card"] + "  top-radius-blog img-100"}
                              src={data.urlImage + ""}
                              alt=""
                            />
                            <div className="product-hover">
                              <ul>
                                <li onClick={() => props.handleClickThematicFolder(data.thematicFolderId)}>
                                  <i className="icon-eye"></i>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="align-middle">{selectedLanguage === "en" ? data.titleAnglais : data.titleFrancais}</td>
                      <td className="align-middle">{selectedLanguage === "en" ? "Thematic folder" : "Dossier thématique"}</td>
                      <td className="align-middle">-- --</td>
                      <td className="align-middle">-- --</td>
                      {hasRoleAdmin && (
                        <td onClick={event => event.stopPropagation()} className={`${styles["document-table-actions-icons"]} align-middle text-center`}>
                          <ClickAwayListener onClickAway={() => setDropdownOpen(false)}>
                            <div className={`${styles["translate_wrapper-view"]} ${dropdownOpen && index === indexVideo ? styles["active"] : ""}`}>
                              <div onClick={event => event.stopPropagation()} className={styles["current_lang-view"]}>
                                <div
                                  className={styles["lang-view"] + " " + styles["label-list-view"]}
                                  onClick={event => {
                                    event.stopPropagation();
                                    toggle(index);
                                  }}
                                >
                                  <i className={"fa fa-ellipsis-v  " + styles["icon-point"]}></i>
                                </div>
                              </div>
                              <div className={`${styles["more_lang-view"]} ${dropdownOpen && index === indexVideo ? styles["active"] : ""}`}>
                                <div
                                  className={styles["lang-view"]}
                                  onClick={event => {
                                    event.stopPropagation();
                                    setDropdownOpen(false);
                                    props.handleUpdateThematicFolder(data);
                                  }}
                                >
                                  <i id="tableIconBtn" className={`${styles["document-actions__btn-update"]}  fa fa-edit m-t-5`}></i>
                                  <span className={styles["lang-txt-view"]}>{props.t("button_update")}</span>
                                </div>
                                <div
                                  className={styles["lang-view"]}
                                  onClick={event => {
                                    event.stopPropagation();
                                    setDropdownOpen(false);
                                    props.handleRemoveThematicFolder(data.thematicFolderId);
                                  }}
                                >
                                  <i id="tableIconBtn" className={`${styles["document-actions__btn-delete"]} fa fa-trash-o `}></i>
                                  <span className={styles["lang-txt-view"]}>{props.t("button_delete")}</span>
                                </div>
                              </div>
                            </div>
                          </ClickAwayListener>
                        </td>
                      )}
                    </tr>
                  ),
              )}
              {props.listMedia.map(
                (data: any, index: number) =>
                  props.currentPage * props.elementPerPage <= index + props.listFilterThematicFolder.length &&
                  (props.currentPage + 1) * props.elementPerPage > index + props.listFilterThematicFolder.length && (
                    <tr key={data.thematicFolderId}>
                      <td>
                        <div className={styles["card-style"] + " blog-box blog-grid text-center product-box"}>
                          <div className="product-img text-center">
                            {+data.typeCategory === 0 ? (
                              data.support.urlImage ? (
                                <Media
                                  className={styles["img-card"] + "  top-radius-blog img-100"}
                                  onClick={() => {
                                    props.handleClickImage(data);
                                  }}
                                  src={data.support?.urlImage}
                                  alt=""
                                />
                              ) : (
                                <Media
                                  className={styles["img-card"] + "  top-radius-blog img-100"}
                                  onClick={() => {
                                    props.handleClickImage(data);
                                  }}
                                  src={Pdf}
                                  alt=""
                                />
                              )
                            ) : +data.typeCategory === 1 ? (
                              <div className={styles["react-player-container"]}>
                                <ReactPlayer
                                  url={data?.supportVideo?.link}
                                  width="100%"
                                  height="70px"
                                  onError={() => {
                                    toast.error(props.t("message_toastr_inaccessible_video"), {
                                      position: toast.POSITION.TOP_RIGHT,
                                      autoClose: 5000,
                                    });
                                  }}
                                  playing={false}
                                  controls={true}
                                  light={data?.supportVideo?.urlSupport ? data.supportVideo?.urlSupport + "/preview" : false}
                                />
                              </div>
                            ) : (
                              <Media
                                onClick={() => {
                                  props.handleClickImage(data);
                                }}
                                className={styles["img-card"] + " top-radius-blog img-100"}
                                src={data?.exposition?.listExpositionImage[0].urlImage}
                                alt=""
                              />
                            )}
                            <div className="product-hover">
                              <ul>
                                <li onClick={() => props.handleClickImage(data)}>
                                  <i className="icon-eye"></i>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="align-middle">
                        {selectedLanguage === "en" ? data?.exposition?.titleEn : data?.exposition?.titleFr}
                        {data?.support?.title}
                        {data?.supportVideo?.title}
                      </td>
                      <td className="align-middle">
                        {+data.typeCategory === 0 ? props.t("category.label_bibliotheque") : +data.typeCategory === 1 ? props.t("category.label_videotheque") : props.t("category.label_exhibit")}
                      </td>
                      <td className="align-middle">
                        {+data.typeCategory === 0
                          ? data.support.listCountry.map((country: CountryDto) => {
                              return selectedLanguage === "en" ? country.titleAnglais + " " : country.titleFrancais + " ";
                            })
                          : +data.typeCategory === 1
                          ? data.supportVideo.listCountry.map((country: CountryDto) => {
                              return selectedLanguage === "en" ? country.titleAnglais + " " : country.titleFrancais + " ";
                            })
                          : data.exposition.listCountry.map((country: CountryDto) => {
                              return selectedLanguage === "en" ? country.titleAnglais + " " : country.titleFrancais + " ";
                            })}
                      </td>
                      <td className="align-middle">
                        {+data.typeCategory === 0
                          ? data.support.listThematic.map((thematic: ThematicDto) => {
                              return selectedLanguage === "en" ? thematic.titleAnglais + " " : thematic.titleFrancais + " ";
                            })
                          : +data.typeCategory === 1
                          ? data.supportVideo.listThematic.map((thematic: ThematicDto) => {
                              return selectedLanguage === "en" ? thematic.titleAnglais + " " : thematic.titleFrancais + " ";
                            })
                          : data.exposition.listThematic.map((thematic: ThematicDto) => {
                              return selectedLanguage === "en" ? thematic.titleAnglais + " " : thematic.titleFrancais + " ";
                            })}
                      </td>
                      {hasRoleAdmin && (
                        <td onClick={event => event.stopPropagation()} className={`${styles["document-table-actions-icons"]} align-middle text-center`}>
                          <ClickAwayListener onClickAway={() => setDropdownOpen(false)}>
                            <div className={`${styles["translate_wrapper-view"]} ${dropdownOpen && index + props.listFilterThematicFolder.length === indexVideo ? styles["active"] : ""}`}>
                              <div onClick={event => event.stopPropagation()} className={styles["current_lang-view"]}>
                                <div
                                  className={styles["lang-view"] + " " + styles["label-list-view"]}
                                  onClick={event => {
                                    event.stopPropagation();
                                    toggle(index + props.listFilterThematicFolder.length);
                                  }}
                                >
                                  <i className={"fa fa-ellipsis-v  " + styles["icon-point"]}></i>
                                </div>
                              </div>
                              <div className={`${styles["more_lang-view"]} ${dropdownOpen && index + props.listFilterThematicFolder.length === indexVideo ? styles["active"] : ""}`}>
                                <div
                                  className={styles["lang-view"]}
                                  onClick={event => {
                                    event.stopPropagation();
                                    setDropdownOpen(false);
                                    props.removeMediaById(data.thematicFolderMediaId);
                                  }}
                                >
                                  <i id="tableIconBtn" className={`${styles["document-actions__btn-delete"]} fa fa-trash-o `}></i>
                                  <span className={styles["lang-txt-view"]}>{props.t("button_remove")}</span>
                                </div>
                              </div>
                            </div>
                          </ClickAwayListener>
                        </td>
                      )}
                    </tr>
                  ),
              )}
            </tbody>
          </Table>
        </div>
      </Row>
    </>
  );
};

export default translate(ThematicFolderList);
